import  { useState } from "react";
import { useNavigate } from "react-router-dom";

import "./SideDrawer.css";
import ButtonSimp from "../../../components/button";
import {  FaUserCircle } from "react-icons/fa";
import Backdrop from "../../../components/backdrop/Backdrop";
import Modal from "../../../components/modal/Modal";

import Login from "../../../components/form/login/login";
import CategoryTree from "../../../components/category/CategoryTree";
import { Link } from "react-router-dom";
// مسیر صحیح رو تنظیم کن

const SideDrawer = (props) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const modalHandler = () => {
    setShowModal(true);
    props.closeDrawer();
  };

  const modalClosed = () => {
    setShowModal(false);
  };

  let classes = ["SideDrawerLeft", "CloseLeft"];
  if (props.show) {
    classes = ["SideDrawerLeft", "OpenLeft"];
  }

  return (
    <>
      <Backdrop show={props.show} modalClosed={props.closeDrawer} />
      <Modal show={showModal} modalClosed={modalClosed}>
        <Login />
      </Modal>

      <div
        className={`${classes.join(
          " "
        )} bg-dark shadow position-fixed top-0 start-0 vh-100 overflow-auto`}
        style={{
          width: "300px",
          zIndex: 1050,
          transition: "transform 0.3s ease",
        }}
      >
        <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
          <h5 className="m-0 fw-bold">Categories</h5>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={props.closeDrawer}
          >
            ✕
          </button>
        </div>

        <div className="p-3">
          <CategoryTree
            onSelectCategory={(cat) => navigate(`/category/${cat._id}`)}
          />
        </div>

        <div className="border-top mt-3 p-3 text-center">
          {token ? (
            // 👇 اگه لاگین کرده باشه
            <Link
              to="/dashboard/profile"
              className="btn btn-outline-light d-flex align-items-center gap-2"
            >
              <FaUserCircle size={20} />
              <span>Profile</span>
            </Link>
          ) : (
            // 👇 اگه لاگین نکرده باشه
            <ButtonSimp
              margin="3"
              size="md"
              padding="2"
              color="primary"
              text="Login / Sign Up"
              clicked={modalHandler}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SideDrawer;
